import React from "react";

type Props = {};

function Settings({}: Props) {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Settings</h1>
      <p>Here you can find all your settings.</p>
    </div>
  );
}

export default Settings;
